<script>
	import { superadmin } from "./../stores/store.js";
  import {location, link, push} from "svelte-spa-router";
  import active from 'svelte-spa-router/active';
  import { prefix, iduser,user,sucursal,sucursalStore, miPermiso } from "../stores/store";

  //let nombre_usuario = localStorage[$prefix+'_nombre'];

  function salir() { push('/login') }


function changeSucursal(suc)
{
  push('/')
  $sucursal=suc;
}

</script>

<!-- svelte-ignore a11y-invalid-attribute -->
<!-- svelte-ignore a11y-missing-attribute -->
<nav class="navbar navbar-expand-lg navbar-dark bg-dark pt-2 pb-2 bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand mt-0" href="/" use:link>
      <img src="images/logo-scanapp-navbar.png" style='width:90px;'>
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon" />
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav w-100">
        <li class="nav-item">
          <a class="nav-link" aria-current="page" href="/"
            use:link use:active><i class="bi bi-house me-1" />Home</a>
        </li>
        {#if $miPermiso.facturacion.access===true}
            <li class="nav-item">
              <a class="nav-link" href="/facturas"
              use:link use:active><i class="bi bi-cart4 me-1" />Facturas</a>
            </li>
        {/if}
        
        {#if $miPermiso.movimientos.access===true}
            <li class="nav-item">
              <a class="nav-link" href="/movimientos"
              use:link use:active><i class="bi bi-arrows-move me-1" />Movimientos</a>
            </li>
        {/if}

        {#if $miPermiso.movimientos.access===true}
            <li class="nav-item">
              <a class="nav-link" href="/lotes"
              use:link use:active><i class="bi bi-boxes me-1" />Lotes</a>
            </li>
        {/if}
        
        {#if $miPermiso.productos.access===true}
            <li class="nav-item">
              <a class="nav-link" href="/productos"
              use:link use:active><i class="bi bi-box-seam me-1" />Productos</a>
            </li>
        {/if}
        
        {#if $miPermiso.clientes.access===true}
            <li class="nav-item">
              <a class="nav-link" href="/clientes"
              use:link use:active><i class="bi bi-person-square me-1" />Clientes</a>
            </li>
        {/if}
        
        {#if $miPermiso.configuraciones.access===true}
            <li class="nav-item">
              <a class="nav-link" href="/config"
              use:link use:active><i class="bi bi-gear me-1" />Configuración</a>
            </li>
        {/if}
        {#if $miPermiso.stats.access===true}
            <li class="nav-item">
              <a class="nav-link" href="/stats"
              use:link use:active><i class="bi bi-bar-chart-line me-1" />Estadísticas</a>
            </li>
        {/if}

        <div class='col'>

          {#if $superadmin===true}
              <li class="nav-item dropdown float-lg-end">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownMenuLink"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i class="bi bi-shop me-1"></i>{$sucursalStore[$sucursal]}
                </a>
                <ul
                  class="dropdown-menu dropdown-menu-dark dropdown-menu-end"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  {#each Object.entries($sucursalStore) as item}
                      {#if $sucursal!=item[0]}
                        <li>
                          <a href="#" on:click|preventDefault={()=>changeSucursal(item[0])} class="dropdown-item"
                            ><i class="bi bi-shop me-1"></i>{item[1]}</a
                          >
                        </li>
                      {/if}

                  {/each}

                </ul>
              </li>
          {:else}
              <li class="nav-item dropdown float-lg-end">
                  <a class="nav-link"><span class="badge bg-secondary">{$sucursalStore[$sucursal]}</span></a>
              </li>
          {/if}          

          <li class="nav-item dropdown float-lg-end">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="bi bi-person-square me-1" />{$user}
            </a>
            <ul
              class="dropdown-menu dropdown-menu-dark dropdown-menu-end"
              aria-labelledby="navbarDropdownMenuLink"
            >
              <li>
                <a class="dropdown-item" on:click={salir}
                  ><i class="bi bi-door-closed me-1" />Salir</a
                >
              </li>
            </ul>
          </li>
        </div>
      </ul>
    </div>
  </div>
</nav>